import { Box, CircularProgress } from '@mui/material';

// Full-area centered spinner (used in Suspense fallback and initial loads).
export default function LoadingScreen({ height = '60vh' }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height }}>
      <CircularProgress />
    </Box>
  );
}
